import { Component, Input, OnChanges } from '@angular/core';

import { UserCurrency } from '../../../../Core/Users/enums/user-currency';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { FilterTypeRangeModel } from '../../models/filter-type-range.model';
import { RangeModel } from '../../models/range.model';
import { filter } from 'rxjs';

@Component({
    selector: 'agpr-filter-range',
    templateUrl: './filter-range.component.html',
    styleUrls: ['./filter-range.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterRangeComponent
        }
    ],
    standalone: false
})
export class FilterRangeComponent extends AbstractFilterTypeComponent implements OnChanges {
    @Input() declare filter: FilterTypeRangeModel;

    value: RangeModel;
    searchQuery: string;

    minValueForMax: number;
    maxValueForMin: number;
    userCurrency: UserCurrency;

    readonly styleEnum = AgprComponentStyleEnum;

    constructor(private currentUserStateService: CurrentUserStateService){
        super();
        this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(pref => {
            this.userCurrency = pref.currency;
        });
    }


    ngOnChanges(): void {
        this.searchQuery = '';
        this.refresh();
    }

    /**
     * Refreshes the current value of the filter
     */
    refresh(): void {
        this.value = this.filter.getCurrentValue();
        this.setAvailableRanges();
    }

    /**
     * Updates the current value of the filter
     */
    update(): void {
        this.filter.setCurrentValue(this.value);
        this.setAvailableRanges();
    }

    /**
     * Updates the ranges for the min/max inputs
     */
    setAvailableRanges(): void {
        this.minValueForMax = this.filter.min;
        this.maxValueForMin = this.filter.max;

        if (!isNaN(this.value.min)) {
            this.minValueForMax = this.value.min;
        }
        if (!isNaN(this.value.max)) {
            this.maxValueForMin = this.value.max;
        }
    }

    /**
     * Handles moving focus away from the "min" input
     */
    focusOutMin(): void {
        if (this.value.min === null) {
            if (this.filter.allowNullMin){
                this.update();
            }else{
                // isNaN treats null as a number, convert it to undefined
                this.value.min = undefined;
                this.update();
            }
        }
        if (isNaN(this.value.min)) {
            return;
        }
        if (!isNaN(this.value.max) && this.value.min > this.value.max ) {
            this.value.min = this.value.max;
            this.update();
        }
        if (this.value.min < this.filter.min || this.value.min > this.filter.max) {
            this.value.min = this.filter.min;
            this.update();
        }
    }

    /**
     * Handles moving focus away from the "max" input
     */
    focusOutMax(): void {
        if (this.value.max === null) {
            // isNaN treats null as a number, convert it to undefined
            this.value.max = undefined;
            this.update();
        }
        if (isNaN(this.value.max) ) {
            return;
        }

        if (!isNaN(this.value.min) && this.value.min > this.value.max ) {
            this.value.max = this.value.min;
            this.update();
        }
        if (this.value.max > this.filter.max || this.value.max < this.filter.min) {
            this.value.max = this.filter.max;
            this.update();
        }
    }

    /**
     * onKeydown event
     */
    onKeydown(event: KeyboardEvent): boolean {
        // block 'e' and 'E' on keydown because input number allows e/E which stands for exponential
        if (event.code === 'KeyE') {
            return false;
        }
        // if the input only accepts integer, block '.' on keydown
        if (event.key === '.' && this.filter.integerOnly) {
            return false;
        }
    }
}
